import React from "react";
import { useSelector } from "react-redux";
import Icon from "../AppIcon";
import Badge from "../badge";

// NotificationBell is a visual-only component (no interactive wrapper).
// The interactive trigger is provided by the consuming parent (e.g., Popover.Trigger in NotificationsMenu).
const NotificationBell = () => {
  const notificationsTotalUnreadCount = useSelector(
    (state: any) => state.notifications.notificationsTotalUnreadCount
  );

  return (
    <Badge count={notificationsTotalUnreadCount ?? 0}>
      <div className="p-2">
        <Icon name="Bell" size={20} className="text-muted-foreground" />
      </div>
    </Badge>
  );
};

export default NotificationBell;
